import Swal from 'sweetalert2';

/**
 * Manipula erros de API do Axios e exibe um modal SweetAlert2 padronizado.
 * Ele analisa erros de validação no estilo Laravel ou uma mensagem de erro simples da resposta.
 *
 * @param {object} error O objeto de erro de um bloco .catch().
 * @param {string} [defaultTitle='Ops!'] O título padrão para o alerta.
 * @param {string} [defaultMessage='Ocorreu um erro...'] A mensagem padrão se nenhum erro específico for encontrado.
 */
export const handleApiError = (error, defaultTitle = 'Ops!', defaultMessage = 'Ocorreu um erro ao processar sua solicitação. Por favor, tente novamente.') => {
    const responseData = error?.response?.data;
    let title = defaultTitle;
    let message = defaultMessage;

    if (responseData) {
        if (responseData.errors && typeof responseData.errors === 'object' && Object.keys(responseData.errors).length > 0) {
            const errorList = Object.values(responseData.errors).flat();
            message = `<ul style="text-align: left; list-style-position: inside; padding-left: 0;">${errorList.map(e => `<li>${e}</li>`).join('')}</ul>`;
        }
        else if (responseData.message) {
            message = responseData.message;
        }
    }

    if (error?.response?.status === 500) {
        message = 'Ocorreu um erro interno no servidor. Por favor, tente novamente mais tarde.';
    }

    Swal.fire({ title, html: message, icon: 'warning' });
};